import { identifyUser, trackEvent } from '../components/analytics/analytics'
import { TRACK_EVENTS } from '../constants'

// Segment events for the floating LAYI widget and the LAYI notifications switch. Since the
// conversation moved inside the embedded Chainlit UI, only the panel's open/close are observable from
// app code; the LAYI backend's Postgres (Chainlit data layer + per-turn token accounting) is the record
// of the conversations themselves. Analytics for the embedded chat are a separate task.

const CHATBOT_PLATFORM = 'web'

// app_version has no source in this repo yet (REACT_APP_VERSION is unset and react-scripts does
// not inline package.json's version). Attached only when a build provides it — same plumbing as
// csatTracking.js, so the day ops wires the build arg every cluster picks it up.
const getAppVersion = () => process.env.REACT_APP_VERSION || undefined

// Always stamp platform + (when present) app_version, and drop empty values so events carry no
// undefined/null/'' noise — 0 is a real value (seconds_open) and stays.
const withBaseProperties = (properties = {}) => {
  const merged = { platform: CHATBOT_PLATFORM, app_version: getAppVersion(), ...properties }
  return Object.keys(merged).reduce((accumulator, key) => {
    const value = merged[key]
    if (value !== undefined && value !== null && value !== '') accumulator[key] = value
    return accumulator
  }, {})
}

export const trackChatbotPanelOpened = ({ page }) => trackEvent(TRACK_EVENTS.CHATBOT_PANEL_OPENED, withBaseProperties({ page }))

export const trackChatbotPanelClosed = ({ secondsOpen }) => trackEvent(TRACK_EVENTS.CHATBOT_PANEL_CLOSED, withBaseProperties({ seconds_open: secondsOpen }))

// The notifications switch runs these after the browser's answer: a blocked Segment script (no
// window.analytics) must never break it, so they swallow any error.
const safely = send => {
  try {
    send()
  } catch (error) {
    // Analytics unavailable: the decision is still kept in this browser.
  }
}

// result: on | off | blocked | dismissed (the browser's prompt closed without an answer); source: menu | invite.
export const trackLayiNotificationsChanged = ({ result, source }) =>
  safely(() => trackEvent(TRACK_EVENTS.CHATBOT_NOTIFICATIONS_CHANGED, withBaseProperties({ result, source })))

// The user's latest decision on their Segment profile, readable across devices (like the CSAT answer).
export const identifyLayiNotifications = ({ userId, state, at }) => {
  if (!userId) return
  safely(() => identifyUser(String(userId), { layi_notifications: state, layi_notifications_at: at }))
}
